import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Route, Redirect, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import uuidv4 from 'uuid/v4';

import {
  resetValue,
  updateItem,
} from 'actions/settings';

import { RouteSwitch } from 'components';

import { Exit } from 'screens/shared';

import HistoricalError from './HistoricalError/HistoricalError';
import Alarms from './Alarms/Alarms';
import EngineSettings from './EngineSettings/EngineSettings';
import FactoryDefaults from './FactoryDefaults/FactoryDefaults';

class Settings extends Component {
  constructor(props) {
    super(props);

    this.state = this.getInitialState();
  }

  getInitialState() {
    const settingsComponents = {
      historicalError: {
        name: HistoricalError,
        route: 'historical-error',
        actions: ['changeState'],
        startScreen: true,
        selected: 0
      },
      alarms: {
        name: Alarms,
        route: 'alarms',
        actions: ['updateItem', 'changeState'],
        startScreen: true,
        selected: null
      },
      engineSettings: {
        name: EngineSettings,
        route: 'engine-settings',
        actions: ['updateItem', 'changeState'],
        startScreen: true,
        selected: null
      },
      factoryDefaults: {
        name: FactoryDefaults,
        route: 'factory-defaults'
      }
    };

    const { components } = this.props;

    return {
      components: { ...settingsComponents, ...components },
      actionCallbacks: {
        resetValue: this.handleReset,
        updateItem: this.handleUpdateItem,
        changeState: this.handleStateChange
      }
    };
  }

  componentWillReceiveProps(nextProps) {
    const { location } = this.props;

    if (location.pathname !== nextProps.location.pathname) {
      this.setState(this.getInitialState());
    }
  }

  handleReset = (screen, item) => {
    this.props.resetValue({
      screen,
      item
    });
  }

  handleUpdateItem = (screen, item) => {
    this.props.updateItem({
      screen,
      item
    });
  }

  handleStateChange = (screen, selectedItem, isStart = false) => {
    const { components } = this.state;

    this.setState({
      components: {
        ...components,
        [screen]: {
          ...components[screen],
          startScreen: isStart,
          selected: selectedItem
        }
      }
    });
  };

  renderRoutes = (components) => {
    const { match, content } = this.props;
    const { actionCallbacks } = this.state;

    return Object.keys(components).map((key) => {
      const comp = components[key];
      const {
        name,
        route,
        actions,
        ...additionalProps
      } = comp;
      const ComponentName = name;

      let componentProps = {
        id: key,
        content: content[key]
      };

      if (actions) {
        componentProps = {
          ...componentProps,
          ...additionalProps
        };

        actions.forEach((action) => {
          componentProps[action] = actionCallbacks[action];
        });
      }

      return (
        <Route
          exact
          path={`${match.url}/${route}`}
          key={uuidv4()}
          render={routeProps =>
            (<ComponentName
              {...routeProps}
              {...componentProps}
            />)}
        />
      );
    });
  }

  render() {
    const { match, content } = this.props;
    const { components } = this.state;
    const { url } = match;

    let output = <div />;

    if (Object.keys(content).length > 0) {
      output = (
        <RouteSwitch>
          {this.renderRoutes(components)}
          <Route
            exact
            path={`${url}/exit`}
            render={() =>
              (<Exit
                text={content.exit.title}
                destinations={content.exit.routes}
              />)
            }
          />
          <Redirect from={url} to={`${url}/trans-oil`} />
        </RouteSwitch>
      );
    }

    return output;
  }
}

Settings.defaultProps = {
  content: null
};

Settings.propTypes = {
  match: PropTypes.shape({
    url: PropTypes.string.isRequired
  }).isRequired,
  location: PropTypes.shape({
    pathname: PropTypes.string.isRequired
  }).isRequired,
  content: PropTypes.shape({}),
  components: PropTypes.shape({}).isRequired,
  resetValue: PropTypes.func.isRequired,
  updateItem: PropTypes.func.isRequired
};

export default withRouter(connect(({ settings }) => ({
  content: settings
}), {
  resetValue,
  updateItem
})(Settings));




// WEBPACK FOOTER //
// ./src/screens/shared/Settings/Settings.js